import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const startNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.START,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: FlowNodeTypes.START,
    settingsTitle: "Greeting Message",
    nodeTitle: "Greeting Message",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "Scripted Greeting",
        description:
          "Initiates the conversation with a friendly greeting, setting expectations for the user’s interaction with the assistant.",
        params: [
          {
            label: "Greeting",
            placeholder: "Hello! How can I help you?",
            type: SettingParamTypes.PROMPT,
            key: "scripted_greeting",
            value: "",
            required: true,
            requiredLabel:
              "Specify a greeting message so that the assistant can start the conversation",
          },
        ],
      },
    ],
  },
};
